// eslint-disable-next-line import/prefer-default-export
export const formValidator = (formValues, validators) => {
  let errors = {};

  validators.forEach((validator) => {
    errors = {
      ...errors,
      ...validator(formValues),
    };
  });

  return errors;
};
